import {
    get
} from "@/common/request"

export function GetHomePageData() {
    return get("home/get")
}